import React from "react";
import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { useHotelApplicationDataQuery } from "@/components/features/_shared/repository/hotel-application-data/query";

import { useFetchGoogleFreeBookingLinksSettingsHotelTypeSelectionModal } from "../api";
import { ModalGoogleFreeBookingLinksIslandSettings } from "./modal";

type Props = {
	hotelID: string;
};

export const GoogleFreeBookingLinksSettingsHotelTypeSelectionModal: React.FC<Props> = ({ hotelID }) => {
	const { data } = useFetchGoogleFreeBookingLinksSettingsHotelTypeSelectionModal({ hotelID });
	const { hotelApplicationData } = useHotelApplicationDataQuery(hotelID);

	if (!data || !hotelApplicationData) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return (
		<ModalGoogleFreeBookingLinksIslandSettings
			googleFreeBookingLinksSettingsQueryData={data}
			hotelApplicationData={hotelApplicationData}
		/>
	);
};
